import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SettingsContext = createContext(null);

const DEFAULTS = {
  platform_name: "مخزون كار",
  legal_name: "مخزون كار",
  address: "حي الفيصلية، جدة، المملكة العربية السعودية",
  cr_number: "7054960856",
  tax_number: "",
  support_whatsapp: "0569149795",
  support_email: "",
  license_info: "",
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);
  useEffect(() => {
    api.get("/settings/public").then(({ data }) => setSettings({ ...DEFAULTS, ...data })).catch(() => {});
  }, []);
  return <SettingsContext.Provider value={settings}>{children}</SettingsContext.Provider>;
}

export const useSettings = () => useContext(SettingsContext) || DEFAULTS;
